import * as Yup from "yup";

export const LoginSchema = Yup.object().shape({
  mail: Yup.string().required("E-mail is required."),
  password: Yup.string().required("Password is required."),
});
export const ConfirmLoginSchema = Yup.object().shape({
  code: Yup.string().required("Login code is required."),
});
export const RegisterSchema = Yup.object().shape({
  firstname: Yup.string().required("Firstname is required."),
  lastname: Yup.string().required("Lastname is required."),
  mail: Yup.string().required("Address E-Mail is required."),
  password: Yup.string()
    .required("Password is required")
    .min(6, "The password must contain at least 6 characters."),
  confirmPassword: Yup.string()
    .required("Confirm password is required")
    .oneOf([Yup.ref("password"), null], "The password and confirm password must match!"),
});
export const RegisterCompleteSchema = Yup.object().shape({
  register_code: Yup.string().required(
    "Please provide the code you received in your mail box from sign up.",
  ),
  firstname: Yup.string().required("Firstname is required."),
  lastname: Yup.string().required("Lastname is required."),
  gender: Yup.string().required("Gender is required."),
  birth: Yup.string().required("Date of birth is required."),
  birth_location: Yup.string().required("Location of birth is required."),
  origin_country: Yup.string().required("Country of origin is required."),
  profession: Yup.string().required("Profession is required."),
  school: Yup.string().required("School is required."),
  stream: Yup.string().required("Stream is required."),
  program_language: Yup.string().required(
    "Please select the language for course program.",
  ),
  expectations: Yup.string().required(
    "Please provide your expectations from the registration to Pamoja4MI University.",
  ),
  agreement: Yup.boolean().oneOf(
    [true],
    "You have to be agree with the conditions of Pamoja4MI University.",
  ),
});
export const NewRegisterSchema = Yup.object().shape({
  school: Yup.string().required("School is required."),
  stream: Yup.string().required("Stream is required."),
  program_language: Yup.string().required(
    "Please select the language for course program.",
  ),
  expectations: Yup.string().required(
    "Please provide your expectations from the registration to Pamoja4MI University.",
  ),
});

// User
export const UserRegisterSchema = Yup.object().shape({
  firstname: Yup.string().required("Firstname is required."),
  lastname: Yup.string().required("Lastname is required."),
  gender: Yup.string().required("Gender is required."),
  mail: Yup.string()
    .required("E-mail is required.")
    .email("Invalid email format"),
  date_of_birth: Yup.string().required("Date of birth is required."),
  location_of_birth: Yup.string().required("Location of birth is required."),
  origin_country: Yup.string().required("Country of origin is required."),
});

// Subscription
export const SubscriptionBankSchema = Yup.object().shape({
  card_number: Yup.string().required("This field is required."),
  card_expiry_date: Yup.string().required("This field is required."),
  card_CVC: Yup.string().required("This field is required."),
});
export const SubscriptionMobileSchema = Yup.object().shape({
  card_number: Yup.string().required("This field is required."),
});
// Password
export const PasswordSchema = Yup.object().shape({
  old_password: Yup.string().required("Old password is required."),
  
  password: Yup.string()
    .required("The new password is required")
    .min(6, "The password must have at least 6 caractors"),
  confirm_password: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "The passwords(new and confirm) must match!"
  ),
});
